export enum authGuards {
    RESTAURANT = 'restaurant',
    CHAIN = 'chain',
    JET_EMPLOYEE = 'jet-employee'
}
